import Queue from '@mui/icons-material/Queue';
import {Link} from 'react-router-dom';
import queryString from 'query-string';
import {
  useResourceContext,
  useRecordContext,
  useCreatePath,
  Button,
} from 'react-admin';
import log from "loglevel";
import React from "react";

const defaultIcon = <Queue />;

// useful to prevent click bubbling in a datagrid with rowClick
const stopPropagation = e => e.stopPropagation();

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const omitId = ({_id, ...rest}) => rest;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const omitAliasIds = ({aliases}) => aliases.map(({_id, ...rest}) => rest);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const omitConstraintIds = ({constraints}) => constraints.map(({_id, ...rest}) => rest);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const omitValueIds = ({values}) => values.map(({_id, ...rest}) => rest);

/**
 * Clone a dictionary entry
 * dictId is in filter property
 * Removes IDs from alias list as well as entry ID to force new db subdocuments.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export const UnCloneButton = (props) => {
  const {
    label = 'ra.action.clone',
    scrollToTop = true,
    icon = defaultIcon,
    filter,
    ...rest
  } = props;
  const resource = useResourceContext(props);
  const record = useRecordContext(props);
  const createPath = useCreatePath();
  const pathname = createPath({resource, type: 'create'}) ;
  record.aliases = omitAliasIds(record);
  record.constraints = omitConstraintIds(record);
  record.values = omitValueIds(record);
  log.debug("{omitAliasIds} aliases with no ids:", record.aliases);
  return (
    <Button
      component={Link}
      to={
        record
          ? {
            pathname,
            search: queryString.stringify({
              filter: JSON.stringify(filter),
              source: JSON.stringify(omitId(record)),
            }),
            state: {_scrollToTop: scrollToTop},
          }
          : pathname
      }
      label={label}
      onClick={stopPropagation}
      {...rest}
    >
      {icon}
    </Button>
  );
};

export default UnCloneButton;